import { gql } from '@apollo/client';

export default gql`
  mutation updateBookingExtras($currency: String!, $bookingReference: String!, $segments: [InputSegment]) {
    updateBookingExtras(currency: $currency, bookingReference: $bookingReference, segments: $segments) {
      reference
      currency
      pendingCreationLegs {
        bookingItems: products {
          itemRef
          associatedItemRefs
          passengerId
          price: priceWithCurrency
          loyaltyPoints
          tariffDetails {
            tariffCode
          }
          code
          inventoryClass
          name
          type
          currency
          passenger {
            id
            firstName
            lastName
            type
          }
        }
      }
      pendingCancellationLegs {
        bookingItems: products {
          itemRef
          associatedItemRefs
          passengerId
          price: priceWithCurrency
          loyaltyPoints
          tariffDetails {
            tariffCode
          }
          code
          inventoryClass
          name
          type
          currency
          passenger {
            id
            firstName
            lastName
            type
          }
        }
        serviceType {
          code
        }
      }
    }
  }
`;
